import Button from "../../components/Shared/Button";
import { useState } from "react";
import AddIcon from "../../components/Icons/AddIcon";
import { useQuery } from "@tanstack/react-query";
import Spinner from "../../components/Shared/Spinner";
import { getReviews } from "../../api/Reviews/GetAllReviews";
import ReviewTable from "../../components/Dashboard/Reviews/ReviewTable";
import AddReview from "../../components/Dashboard/Reviews/AddReview";
import DashboardInlineBackButton from "../../components/Dashboard/Shared/DashboardInlineBackButton";
const Reviews = () => {
  const [showManageReviews, setShowManageReviews] = useState(false);
  const { data: ReviewsResponse, isLoading: isReviewsLoading } = useQuery({
    queryFn: getReviews,
    queryKey: ["reviews"],
    staleTime: 0,
    refetchInterval: 0,
  });
  const reviewData = ReviewsResponse?.data?.reviewData || [];
  return (
    <div className="py-7">
      <div className="flex justify-between">
        <h1 className="text-burntBlack font-bold text-[32px] mb-7">Reviews</h1>
        <Button
          onClick={() => setShowManageReviews(true)}
          className="!h-12 w-40 !text-sm font-bold rounded-md !bg-[#4379EE] hover:!bg-primary"
          variant="primary"
        >
          <AddIcon className="mr-1.5" />
          Add New Review
        </Button>

      </div>
      <div className="p-8 rounded-3xl shadow bg-white border border-black/15">
        {showManageReviews ? (
          <div className="space-y-4">
            <DashboardInlineBackButton
              label="Back to reviews"
              onClick={() => setShowManageReviews(false)}
            />
            <AddReview onSuccess={() => setShowManageReviews(false)} />
          </div>
        ) : (
          <>
            {isReviewsLoading ? (
              <div className="min-h-[50vh] flex justify-center items-center">
                <Spinner />
              </div>
            ) : (
              <ReviewTable data={reviewData} />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Reviews;
